import httpInterceptor from './http-interceptor';
import localStorage from './local-storage';
import numInputDecorator from './num-input-config';
import datepickerFormatter from './datepicker-formatter';
import tagsInputConfig from './tags-input-config';
import protocolWhitelistConfig from './protocol-whitelist';
import urlFormatter from './url-formatter';
import killRejectionError from './kill-rejection-error';

export default function (app) {
	httpInterceptor(app);
	localStorage(app);
	numInputDecorator(app);
	datepickerFormatter(app);
	tagsInputConfig(app);
	protocolWhitelistConfig(app);
	urlFormatter(app);
	killRejectionError(app);
};
